// tslint:disable no-console
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

enum LogLevel {
  DEBUG,
  INFO,
  WARN,
  ERROR,
  FATAL,
}

const printers = {
  [LogLevel.DEBUG]: console.debug,
  [LogLevel.INFO]: console.info,
  [LogLevel.WARN]: console.warn,
  [LogLevel.ERROR]: console.error,
  [LogLevel.FATAL]: console.error,
};

@Injectable()
export class LogService {
  level: LogLevel;

  constructor() {
    // only output error logs in production mode
    this.level = environment.production ? LogLevel.ERROR : LogLevel.DEBUG;

    (window as any).enableDebugMode = () => {
      this.level = LogLevel.DEBUG;
      console.log('Debug Mode Enabled');
    };
    (window as any).disableDebugMode = () => {
      this.level = LogLevel.ERROR;
      console.log('Debug Mode Disabled');
    };
  }

  private checkLevel(logLevel: LogLevel) {
    return logLevel >= this.level;
  }

  private get timestamp(): string {
    return new Date(Date.now()).toLocaleString();
  }

  private printTrace() {
    console.groupCollapsed('Stack traces:');
    console.trace();
    console.groupEnd();
  }

  private printLog(logLevel: LogLevel, title: string, message: any, meta?: any) {
    console.group(`[${title}] ${this.timestamp}`);
    printers[logLevel](message);
    if (meta) {
      printers[logLevel](meta);
    }
    this.printTrace();
    console.groupEnd();
  }

  debug(message: any, params?: any, title?: string) {
    if (this.checkLevel(LogLevel.DEBUG)) {
      this.printLog(LogLevel.DEBUG, title || 'DEBUG', message, params);
    }
  }

  info(message: any, params?: any, title?: string) {
    if (this.checkLevel(LogLevel.INFO)) {
      this.printLog(LogLevel.INFO, title || 'INFO', message, params);
    }
  }

  warn(message: any, params?: any, title?: string) {
    if (this.checkLevel(LogLevel.WARN)) {
      this.printLog(LogLevel.WARN, title || 'WARN', message, params);
    }
  }

  error(message: any, params?: any, title?: string) {
    if (this.checkLevel(LogLevel.ERROR)) {
      this.printLog(LogLevel.ERROR, title || 'ERROR', message, params);
    }
  }

  fatal(message: any, params?: any, title?: string) {
    if (this.checkLevel(LogLevel.FATAL)) {
      this.printLog(LogLevel.FATAL, title || 'FATAL', message, params);
    }
  }
}
